import { render, staticRenderFns } from "./Racial.vue?vue&type=template&id=958dc108&scoped=true&"
import script from "./Racial.vue?vue&type=script&lang=js&"
export * from "./Racial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958dc108",
  null
  
)

export default component.exports